import { render, staticRenderFns } from "./profileLayout.vue?vue&type=template&id=5a61b7fa&"
import script from "./profileLayout.vue?vue&type=script&lang=js&"
export * from "./profileLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports